import { SxProps, TextField as MuiTextField, Theme } from '@mui/material'
import React from 'react'
import { Control, Controller } from 'react-hook-form'

type TextFieldProps = {
  label?: string
  name: string
  placeholder?: string
  maxLength?: number
  minRows?: number
  multiline?: boolean
  sx?: SxProps<Theme>
  control: Control<any>
  disabled?: boolean
}

const FormInputNumber: React.FC<TextFieldProps> = ({
  label,
  name,
  placeholder,
  maxLength,
  multiline,
  minRows,
  sx,
  control,
  disabled,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <MuiTextField
          fullWidth
          id={`${name}Id`}
          label={label}
          name={name}
          value={value || ''}
          size='small'
          placeholder={placeholder}
          onChange={(e) => {
            // Permitir apenas números no input
            const inputValue = e.target.value.replace(/\D/g, '')

            // Converter para número ou retornar undefined se estiver vazio
            const numericValue = inputValue ? Number(inputValue) : undefined

            onChange(numericValue)
          }}
          InputProps={{
            inputProps: {
              maxLength: maxLength,
            },
          }}
          minRows={minRows}
          multiline={multiline}
          sx={sx}
          error={!!error}
          helperText={error && error.message && error.message}
          disabled={disabled}
        />
      )}
    />
  )
}

export default FormInputNumber
